<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">个人信息</p>
				</div>
				<div class="f16px cl_yel mat30">温馨提示：你必须填写你的真实姓名，老师会严格审核你的信息的。</div>
				<div class="mat30 my_info_cont">
					<input type="text" placeholder="请填写你的真实姓名" maxlength="10" v-model="real_name" class="add_search_input f16px" @input="realName" />
					<button class="cl_white radius20 f16px my_info_btn" @click="save">保存</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	
	export default {
		name: 'my_info',
		components: {
			studentNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 3,
					listCur: 0,
					open: 0,
				},
				real_name: "",
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
				if (this.myInfo.real_name) {
					this.real_name = this.myInfo.real_name;
				}
			},
			publicEvent (data) {
				this.public = data;
			},
			realName () {
				
			},
			save () {
				this.$get("/api/user/post_edit_real_name",{
					token: localStorage.getItem("token"),
					name: this.real_name,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					location.reload();
				});
			},
		},
	}
</script>

<style>
</style>
